import { render } from "./App.vue?vue&type=template&id=e50ad886"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e50ad886&lang=css"

import exportComponent from "D:\\wamp\\www\\yunmuyuan_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__